import { RootState } from '../../store/root-state';

export const getUserLoadingState = (state: RootState) => state.loading.user;
export const getProjectLoadingState = (state: RootState) => state.loading.project;
export const getDocumentLoadingState = (state: RootState) => state.loading.document;
export const getDocumentsLoadingState = (state: RootState) => state.loading.documents;
export const getProjectsLoadingState = (state: RootState) => state.loading.projects;
export const getSecurityLoadingState = (state: RootState) => state.loading.security;
export const getGroupsLoadingState = (state: RootState) => state.loading.groups;
